import { CircularProgress, Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

export const LoadingSpinner = ({ message, size = 40 }: LoadingSpinnerProps) => {
  const { t } = useTranslation();
  const messageToShow = message || t('common.loading');

  return (
    <Stack alignItems="center" justifyContent="center" minHeight={200} gap={2}>
      <CircularProgress size={size} />
      <Typography variant="body2" color="text.secondary">
        {messageToShow}
      </Typography>
    </Stack>
  );
};
